import styled, { css } from 'styled-components';

export const CatalogListStyled = styled.ul`
    ${({ theme }) => css`
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin: 0 calc(-${theme.gap.default} / 2) 40px;
        padding: 0;
    `}
`;

export default CatalogListStyled;
